var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isHolding(_vm.loggedUserData) ? _c("div", {
    staticClass: "submenus"
  }, [_c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.orders
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.orders ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Orders")])])]), _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.creditNote
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.creditNote ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Credit Notes")])])])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };